<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row mt-2">
      <div class="col-12">
        <h4>Bienvenue sur Lettre Compte Triple</h4>
      </div>
      <div class="col-12 col-lg-9">
        <GameChatStomp gameId="1" v-bind:showTime="true"></GameChatStomp>
      </div>
      <div class="d-none d-lg-block col-lg-3 player-list">
        <input type="text" class="form-control" v-model="filter"
        placeholder="filtre sur les joueurs"/>
        <ul class="list-group list-group-flush">
          <li v-for="(player, index) in filteredPlayers" v-bind:key="index" class="list-group-item">
            <Player
              v-bind:username="player.username"
              v-bind:userId="player.id"
              v-bind:picture="player.picture"/>
          </li>
        </ul>
      </div>
    </div>
    <div class="row d-none d-md-flex">
      <div class="col-4 col-md-8 col-lg-9 text-right">
        Faites connaître LCT à vos amis (<a href=" https://www.facebook.com/lettrecomptetriple/" target="_blank">Plus de news sur la page facebook</a>)
      </div>
      <div class="col-8 col-md-4 col-lg-3">
        <div class="fb-like" data-href="http://www.facebook.com/pages/Lettre-Compte-Triple/333497076676866"
            data-width="120" data-layout="button_count"
            data-action="like" data-size="small" data-share="true"></div>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row mt-4">
        <div class="col-12">
          <h4>Choisissez une partie créée automatiquement</h4>
        </div>
        <div class="col-12 mb-2 d-none d-lg-block">
          <access-game-list v-bind:games="autoGames"
            v-bind:players="players" />
        </div>
        <div class="col-lg-3 mb-2 d-lg-none"
          v-for="game in autoGames" v-bind:key="game.name">
          <access-game-card
          v-bind:game="game"
          v-bind:players="getGamePlayers(game.id)"
          ></access-game-card>
        </div>
        <div class="col-12" v-if="createdByPlayersGames.length > 0">
          <h4>ou une partie proposée par un joueur</h4>
        </div>
        <div class="col-12 mb-2 d-none d-lg-block" v-if="createdByPlayersGames.length > 0">
          <access-game-list v-bind:games="createdByPlayersGames"
            v-bind:players="players" />
        </div>
        <div class="col-lg-3 mb-2 d-lg-none"
          v-for="game in createdByPlayersGames" v-bind:key="game.name">
          <access-game-card
          v-bind:game="game"
          v-bind:players="getGamePlayers(game.id)"
          ></access-game-card>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-12">
          <h4>Créer une partie ?</h4>
        </div>
        <div class="col-lg-3 mb-2">
          <add-game-card></add-game-card>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <img :src="momentImg" width="100%"/>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../iam';
import AccessGameCard from './AccessGameCard';
import AddGameCard from './AddGameCard';
import LoggedUser from './LoggedUser';
import GameChatStomp from './games/GameChatStomp';
import BottomNav from './BottomNav';
import AccessGameList from './AccessGameList';
import Player from './Player';

export default {
  name: 'Lobby',
  data() {
    return {
      loading: true,
      createdByPlayersGames: [],
      autoGames: [],
      toStartGames: [],
      players: [],
      gamers: [],
      timeout: undefined,
      filter: '',
    };
  },
  components: {
    LoggedUser,
    AccessGameCard,
    GameChatStomp,
    BottomNav,
    AddGameCard,
    AccessGameList,
    Player,
  },
  created() {
    this.loading = true;
    this.init();
  },
  computed: {
    filteredPlayers() {
      return this.filter !== '' ? this.gamers.filter(p => p.username.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) : this.gamers;
    },
    momentImg() {
      const h = new Date().getHours();
      switch (h) {
        case 0:
        case 1: return '/static/late.svg';
        case 2:
        case 3:
        case 4: return '/static/dreamer.svg';
        case 5:
        case 6:
        case 7:
        case 8:
        case 9: return '/static/breakfast.svg';
        case 10:
        case 11: return '/static/hiking.svg';
        case 12:
        case 13: return '/static/barbecue.svg';
        case 14:
        case 15: return '/static/outside.svg';
        case 16: return '/static/outside-reading.svg';
        case 17:
        case 18: return '/static/icecream.svg';
        case 19:
        case 20: return '/static/eating.svg';
        case 21:
        case 22: return '/static/movie_night.svg';
        case 23:
        case 24: return '/static/late.svg';
        default: return '/static/skate.svg';
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  mounted() {
    /* global FB */
    FB.XFBML.parse();
  },
  methods: {
    init() {
      return Promise.all([this.$http.get(`${process.env.LCT_API_URL}/lobby`),
        this.postLobbyPlayers()])
        .then(([lobbyResponse]) => {
          const data = lobbyResponse.data;
          const games = data.games.sort((a, b) => a.roundTime - b.roundTime);
          this.createdByPlayersGames = games.filter(game => game.creator !== 'auto').sort((a, b) => a.locked - b.locked);
          this.autoGames = games.filter(game => game.creator === 'auto');
          this.toStartGames = games
            .filter(game => !game.startDate || Date.parse(game.startDate) > Date.now() + 60000);
          this.players = data.gamePlayers;
          this.gamers = data.lobbyPlayers
            .filter(u => u.username)
            .sort((a, b) => a.username.localeCompare(b.username));
          this.loading = false;
          this.timeout = setTimeout(this.init, 45000);
        });
    },
    async postLobbyPlayers() {
      return this.$http.post(`${process.env.LCT_API_URL}/lobby-players`, {
        username: iam.getConnectedUser().username,
        picture: iam.getConnectedUser().picture,
      });
    },
    getGamePlayers(activeGameId) {
      return this.players.filter(p => p.activeGameId === activeGameId);
    },
    convertDate(timestamp) {
      const date = new Date(timestamp);
      return `${date.toLocaleString()}`;
    },
  },
};
</script>

<style scoped>
.player-list{
  z-index: 1;
}
.player-list ul{
  list-style-type: none;
  height: 290px;
  overflow-y: scroll;
  margin: 4px 0 0 0;
}
.player-list ul .list-group-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Lobby.vue